/**
 * @Author: Zewei
 * @Date:   2018-02-01T10:33:44+08:00
 * @Last modified by:
 * @Last modified time: 2018-02-27T09:46:42+08:00
 */
import _util from '../../utils/';

const rosterService = {
    fetchEmployeesDetailMeta (params, resolve, reject) {
        _util.request({
            url: '/api/HRPartTime/Create',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchEmployeesListAll (params, resolve, reject) {
        _util.request({
            url: '/api/HREmployee/Get?for_all=1',
            params: params,
            success: resolve,
            error: reject
        })
    },
    exportEmployeesList(params, resolve, reject) {
        _util.request({
            url: '/api/HREmployee/Export',
            params: params,
            success: resolve,
            error: reject
        })
    },

    fetchEmployeesList (params, resolve, reject) {
        _util.request({ 
            url: '/api/HREmployee/Get',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchEmployeesUserList (params, resolve, reject) {
        _util.request({
            url: '/api/HREmployee/Get',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchEmployeesDetail (params, resolve, reject) {
        _util.request({
            url: '/api/HREmployee/Details',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchEmployeeChilds (params, resolve, reject) {
        _util.request({
            url: '/api/HREmployeeChild/Get',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchEmployeesDetailByJobNumber (params, resolve, reject) {
        _util.request({
            url: '/api/HREmployee/GetEmployeeByJobNumber',
            params: params,
            success: resolve,
            error: reject
        })
    },

    fetchExportColumn (params, resolve, reject) {
        _util.request({
            url: '/api/HREmployee/Export_Columns',
            params: params,
            success: resolve,
            error: reject
        })
    },
    createEmployee (data, resolve, reject) {
        _util.request({
            url: '/api/HREmployee/Create',
            method: 'POST',
            data: data,
            success: resolve,
            error: reject
        })
    },
        fetchEmployeeInit (params, resolve, reject) {
        _util.request({
            url: '/api/HREmployee/Create',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchEmployeeLeaveDetail(params, resolve, reject) {
        _util.request({
            url: '/api/HREmployeeLeave/DetailByEmployeeId',
            params: params,
            success: resolve,
            error: reject
        })
    },
    exportEmployees (data, resolve, reject) {
        _util.request({
            url: '/api/HREmployee/ExportWithColumns',
            method: 'POST',
            data: data,
            success: resolve,
            error: reject
        })
    },
    importEmployees (data, resolve, reject) {
        // _util.request({
        //     url: '/api/HREmployee/Export',
        //     method: 'POST',
        //     data: data,
        //     success: resolve,
        //     error: reject
        // })
    },
    deleteEmployees (data, resolve, reject) {
        _util.request({
            url: '/api/HREmployee/Delete',
            method: 'DELETE',
            data: data,
            success: resolve,
            error: reject
        })
    },
    deleteEmployeeTrack (data, resolve, reject) {
        _util.request({
            url: '/api/HREmployeeTrack/BatchDelete',
            method: 'DELETE',
            data: data,
            success: resolve,
            error: reject
        })
    },
    uploadEmployeeAvatar (data, resolve, reject) {
        _util.request({
            url: '/api/HREmployee/UploadHeadImage',
            method: 'POST',
            data: data,
            success: resolve,
            error: reject
        })
    },
    fetchEmployeeDetail (params, resolve, reject) {
        _util.request({
            url: `/api/HREmployee/Details?modelId=${params}`,
            // params: params,
            success: resolve,
            error: reject
        })
    },
    editEmployee (data, resolve, reject) {
        _util.request({
            url: '/api/HREmployee/Put',
            method: 'PUT',
            data: data,
            success: resolve,
            error: reject
        })
    },
    leaveJobEmployee (data, resolve, reject) {
        _util.request({
            url: '/api/HREmployee/LeaveJob',
            method: 'PUT',
            data: data,
            success: resolve,
            error: reject
        })
    },
    fetchAllEmployees (params, resolve, reject) {
        _util.request({
            url: '/api/HREmployee/List',
            params: params,
            success: resolve,
            error: reject
        })
    },
    // 公司内兼任 相关
    getPartTimeInit (params, resolve, reject) {
        _util.request({
            url: '/api/HRPartTime/Create',
            params: params,
            success: resolve,
            error: reject
        })
    },
    createPartTime (data, resolve, reject) {
        _util.request({
            url: '/api/HRPartTime/Post',
            method: 'POST',
            data: data,
            success: resolve,
            error: reject
        })
    },
    updatePartTime (data, resolve, reject) {
        _util.request({
            url: '/api/HRPartTime/Put',
            method: 'PUT',
            data: data,
            success: resolve,
            error: reject
        })
    },
    getEmployeePartTimeDetail (params, resolve, reject) {
        _util.request({
            url: '/api/HRPartTime/Get',
            params: params,
            success: resolve,
            error: reject
        })
    },
    getPartTimeDetails (params, resolve, reject) {
        _util.request({
            url: `/api/HRPartTime/Details?modelId=${params}`,
            success: resolve,
            error: reject
        })
    },
    deletePartTime (data, resolve, reject) {
        _util.request({
            url: '/api/HRPartTime/Delete',
            method: 'DELETE',
            data: data,
            success: resolve,
            error: reject
        })
    },
    // updatePartTime (data, resolve, reject) {
    //     _util.request({
    //         url: '/api/HRPartTime/Put',
    //         method: 'PUT',
    //         data: data,
    //         success: resolve,
    //         error: reject
    //     })
    // },
    // 员工 教育信息相关
    createEmployeeEducation (data, resolve, reject) {
        _util.request({
            url: '/api/HREducation/Post',
            method: 'POST',
            data: data,
            success: resolve,
            error: reject
        })
    },
    deleteEmployeeEducation (data, resolve, reject) {
        _util.request({
            url: '/api/HREducation/Delete',
            method: 'DELETE',
            data: data,
            success: resolve,
            error: reject
        })
    },
    updateEmployeeEducation (data, resolve, reject) {
        _util.request({
            url: '/api/HREducation/Put',
            method: 'PUT',
            data: data,
            success: resolve,
            error: reject
        })
    },
    // 员工 工作经历相关
    createEmployeeExperience (data, resolve, reject) {
        _util.request({
            url: '/api/HRWorkExperience/Post',
            method: 'POST',
            data: data,
            success: resolve,
            error: reject
        })
    },
    deleteEmployeeExperience (data, resolve, reject) {
        _util.request({
            url: '/api/HRWorkExperience/Delete',
            method: 'DELETE',
            data: data,
            success: resolve,
            error: reject
        })
    },
    updateEmployeeExperience (data, resolve, reject) {
        _util.request({
            url: '/api/HRWorkExperience/Put',
            method: 'PUT',
            data: data,
            success: resolve,
            error: reject
        })
    },
    deleteChild (data, resolve, reject) {
        _util.request({
            url: '/api/HREmployeeChild/Delete',
            method: 'DELETE',
            data: data,
            success: resolve,
            error: reject
        })
    },
    createChild (data, resolve, reject) {
        _util.request({
            url: '/api/HREmployeeChild/Post',
            method: 'POST',
            data: data,
            success: resolve,
            error: reject
        })
    },
    updateChild(data, resolve, reject) {
        _util.request({
            url: '/api/HREmployeeChild/Put',
            method: 'PUT',
            data: data,
            success: resolve,
            error: reject
        })
    },
    importRoster (posts, resolve, reject) {
        _util.request({
            url: '/api/HREmployee/Import',
            method: 'post',
            data: posts,
            success: resolve,
            error: reject
        })
    },
    downloadTemplate(resolve, reject) {
        _util.request({
            url: '/api/HREmployee/GetImportTemplate',
            success: resolve,
            error: reject
        });
    },
    weixinDepartment(resolve, reject) {
        _util.request({
            url: '/api/HRDepartment/SyncFromWechat',
            method: "post",
            success: resolve,
            error: reject
        });
    },
    weixinEmployee(resolve, reject) {
        _util.request({
            url: '/api/HREmployee/SyncFromWechet',
            method: "post",
            success: resolve,
            error: reject
        });
    },
    arrangePosition(data, resolve, reject) {
        _util.request({
            url: '/api/HREmployeePositionArrange/Post',
            method: "post",
            data: data,
            success: resolve,
            error: reject
        });
    },
    fireEmployee(data, resolve, reject) {
        _util.request({
            url: '/api/HREmployeeLeave/Post',
            method: "post",
            data: data,
            success: resolve,
            error: reject
        });        
    },
    changeJobStatus(data, resolve, reject) {
        _util.request({
            url: '/api/HREmployeeJobStatusArrange/Post',
            method: "post",
            data: data,
            success: resolve,
            error: reject
        });  
    },
    employeeEnrol(data, resolve, reject) {
        _util.request({
            url: '/api/HREmployeeEnroll/Post',
            method: "post",
            data: data,
            success: resolve,
            error: reject
        });  
    },
    employeeEntry(data, resolve, reject) {
        _util.request({
            url: '/api/HREmployeeEntry/Post',
            method: "post",
            data: data,
            success: resolve,
            error: reject
        });  
    },
    selectEmployeeEducation(data, resolve, reject) {
        _util.request({
            url: '/api/HREducation/Get',
            params: data,
            success: resolve,
            error: reject
        });  
    },
    selectEmployeeExperience(data, resolve, reject) {
        _util.request({
            url: '/api/HRWorkExperience/Get',
            params: data,
            success: resolve,
            error: reject
        });  
    },
    selectEmployeeInsure(data, resolve, reject) {
        _util.request({
            url: '/api/HREmployee/InsureInfo',
            params: data,
            success: resolve,
            error: reject
        });  
    },
    updateEmployeeInsure(data, resolve, reject) {
        _util.request({
            url: '/api/HREmployee/InsureInfo',
            method: "put",
            data: data,
            success: resolve,
            error: reject
        });  
    },
    selectEmployeeHoliday(data, resolve, reject) {
        _util.request({
            url: '/api/HREmployee/RelaxationInfo',
            params: data,
            success: resolve,
            error: reject
        });  
    },
    updateEmployeeDetail(data, resolve, reject) {
        _util.request({
            url: '/api/HREmployee/PutOther',
            method: "put",
            data: data,
            success: resolve,
            error: reject
        });  
    },
    selectEmployeeTraining(data, resolve, reject) {
        _util.request({
            url: '/api/HRSalaryTrainingGrant/Get',
            params: data,
            success: resolve,
            error: reject
        });  
    },
    createEmployeeTraining(data, resolve, reject) {
        _util.request({
            url: '/api/HRSalaryTrainingGrant/Post',
            method: "post",
            data: data,
            success: resolve,
            error: reject
        });  
    },
    updateEmployeeTraining(data, resolve, reject) {
        _util.request({
            url: '/api/HRSalaryTrainingGrant/Put',
            method: "put",
            data: data,
            success: resolve,
            error: reject
        });  
    },
    deleteEmployeeTraining(data, resolve, reject) {
        _util.request({
            url: '/api/HRSalaryTrainingGrant/Delete',
            method: "delete",
            data: data,
            success: resolve,
            error: reject
        });  
    },
    selectEmployeeTrack(data, resolve, reject) {
        _util.request({
            url: '/api/HREmployee/Track',
            params: data,
            success: resolve,
            error: reject
        });  
    },
    uploadCertificateImage(data, resolve, reject) {
        _util.request({
            url: '/api/HRCertificate/UploadIdentificationPhoto',
            method: "post",
            data: data,
            success: resolve,
            error: reject
        });          
    },
    uploadSummaryImage(data, resolve, reject) {
      _util.request({
        url: '/api/HRWorkReportMyWeekly/UploadPhoto',
        method: "post",
        data: data,
        success: resolve,
        error: reject
      });
    }
}

export default rosterService;



// WEBPACK FOOTER //
// ./src/services/EmployeeManagement/roster-service.js